<template>
    <v-container>
        <v-dialog v-model="value" scrollable persistent max-width="300px" :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>{{title ? title : $t('event.event_guest')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="$emit('input', false)">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text id="event-guest-picker-scroll-target">
                    <!--<v-layout>-->
                        <!--<v-flex xs12>-->
                            <!--<v-text-field-->
                               <!--@input="searchGuests"-->
                               <!--:label="$t('action.search')"-->
                               <!--v-model="search"-->
                               <!--clearable-->
                               <!--clear-icon="close"-->
                               <!--append-icon="search"-->
                               <!--:loading="searching"-->
                            <!--&gt;</v-text-field>-->
                        <!--</v-flex>-->
                    <!--</v-layout>-->
                        <v-flex xs12>
                            <v-checkbox
                                v-model="is_add_to_group"
                                :label="$t('contact.add_to_group_desc')"
                                class="mt-0"
                            ></v-checkbox>
                        </v-flex>
                    <v-layout>

                    </v-layout>

                    <v-layout v-scroll:#event-guest-picker-scroll-target="onScroll" text-xs-center>
                        <v-flex xs12>
                            <v-list two-line>

                                <v-checkbox
                                        v-model="select_all"
                                        :label="$t('action.select_all') + ' (' + items.length + ')'"
                                        class="mt-0"
                                ></v-checkbox>

                                <template v-for="guest in items">
                                    <v-list-tile
                                            avatar
                                            :key="guest.id"
                                            v-if="multipleSelect"
                                    >
                                        <v-list-tile-action>
                                            <v-checkbox
                                                    v-model="guest.selected"
                                            >
                                                <div slot="label">
                                                    <div class="font-weight-bold">{{guest.name}}</div>
                                                    <div>{{guest.areaCode}} {{guest.phone}}</div>
                                                </div>
                                            </v-checkbox>
                                        </v-list-tile-action>
                                    </v-list-tile>

                                    <v-list-tile
                                            @click="returnGuest(guest)"
                                            avatar
                                            :key="guest.id"
                                            v-else
                                    >
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{guest.name}}</v-list-tile-title>
                                            <v-list-tile-sub-title>{{guest.areaCode}} {{guest.phone}}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-flex>
                    </v-layout>
                    <v-layout v-if="loading" text-xs-center>
                        <v-flex xs12>
                            <v-progress-circular
                                    indeterminate
                                    color="primary"
                            ></v-progress-circular>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions v-if="multipleSelect">
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="$emit('input', false)">{{$t('action.cancel')}}</v-btn>
                    <v-btn color="blue darken-1" flat :disabled="!has_selected_item" @click="returnGuests">{{$t('action.confirm')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import RequestHandler from '~/utils/request-handler'
    import {UrlServices} from "~/utils/url-manager";
    import axios from 'axios';
    import formatter from '~/utils/formatter'

    export default {
        name: "EventGuestPicker",
        props: {
            value: Boolean,         // Set true to show. Do NOT change this name so that we can use v-model in parent components
            title: String,          // Dialog title
            event_id: Number,       // Get guest by event
            multipleSelect: {       // Set true to allow select multiple contacts
                type: Boolean,
                default: true
            },
        },
        data () {
            return {
                is_add_to_group: false,
                is_select_all: false,
                has_selected: false,
                loading: true,
                items: [],
                search: '',
                searching: false,
                cancel: () => {}
            };
        },
        watch: {
            value: function(val) {
                if(val){
                    this.is_select_all = false;
                    this.is_add_to_group = false;
                    this.search = '';
                    this.bottomReached = false;
                    this.getGuests();
                } else {
                    this.page = 1;
                    this.loading = true;
                    this.items = [];
                }
            },
        },
        computed: {
            select_all: {
                get: function () {
                    return _.every(this.items, 'selected');
                },
                set: function (value) {
                    _.each(this.items, function(item){
                        item.selected = value;
                    });
                }
            },
            has_selected_item: {
                get: function () {
                    return _.some(this.items, 'selected');
                }
            },
        },
        methods: {
            getGuests: _.debounce(function(search) {
                let me = this;

                let config = {
                    cancelToken: new axios.CancelToken(function executor(c) {

                    })
                };

                let params = {
                    page: me.page,
                    event_id: this.event_id,
                    search: search
                };

                RequestHandler.Get(UrlServices.createUrl({'name': 'api_event_guest_list'}), params, {
                    'success': function (data) {
                        _.each(data.data, x => {
                            x.selected = false;
                            formatter.parsePhone(x);
                            me.items.push(x);
                        });

                        me.loading = false;
                        me.searching = false;
                        if (me.page < data.total_page) {
                            me.bootomReached = false;
                        } else {
                            me.bottomReached = true;
                        }
                        me.page++;
                    }
                }, config)
            }, 0),
            returnGuests: function() {
                this.$emit('success', _.filter(this.items, x => {
                    return x.selected;
                }), this.is_add_to_group)
            },
            searchGuests: _.debounce(function(search) {
                this.cancel();
                this.page = 1;
                this.items = [];
                this.$nextTick(function() {
                    this.getGuests(search);
                });
            }, 500),
            onScroll(e) {
                if ((e.target.offsetHeight + e.target.scrollTop) >= e.target.scrollHeight) {
                    // you're at the bottom of the page
                    if (!this.bottomReached) {
                        this.bottomReached = true;
                        this.loading = true;
                        this.getGuests();
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>